import { Select } from 'antd';
import { USER_TYPES } from '../constants';

type Role = {
  uuid: string;
  name: string;
};

type MultiSelectProps = {
  rolesData: Role[];
  type: string;
  selectedTags: string[];
  setSelectedTags: (tags: string[]) => void;
};

const MultiSelect = ({
  rolesData,
  type,
  selectedTags,
  setSelectedTags,
}: MultiSelectProps) => {
  const SELECT_ALL_KEY = 'select_all';

  const { Option } = Select;

  const handleChange = (value: any) => {
    if (value.includes(SELECT_ALL_KEY)) {
      if (selectedTags?.length === rolesData.length) {
        setSelectedTags([]);
      } else {
        setSelectedTags(rolesData.map((role: any) => role.uuid));
      }
    } else {
      setSelectedTags(value);
    }
  };

  return (
    <Select
      mode="tags"
      placeholder={`Select or add ${
        type === USER_TYPES.DIVISION ? 'divisions' : 'locations'
      }`}
      defaultValue={selectedTags}
      value={selectedTags}
      onChange={handleChange}
      filterOption={(input, option: any) => {
        const optionLabel = option.label || option.children;
        return optionLabel?.toLowerCase().includes(input.toLowerCase());
      }}
    >
      <Option key="select_all" value="select_all">
        Select All
      </Option>
      {rolesData.length > 0 &&
        rolesData?.map((role: any) => (
          <Option key={role.uuid} value={role.uuid}>
            {role.name}
          </Option>
        ))}
    </Select>
  );
};

export default MultiSelect;
